import { ReactElement } from 'react';

import config from '../config/index.json';

export const FooterLinks = (): ReactElement => {
    const { about } = config;
    const { sections } = about;

    return (
        <div className='flex flex-wrap sm:gap-10 gap-8 items-center justify-center mt-4 h-12'>
            {sections.map(({ href, name, }) => (
                <a
                    key={'${section.name}-${index}'}
                    href={href}
                    className='hover:text-secondary text-base cursor-pointer leading-4 text-gray-800 dark:text-gray-400'
                >
                    {name}
                </a>
            ))}
        </div>
    );
};
